/**
 * 树形车辆的相关 
 */
import request from "@/utils/request";

// 获取车辆的树形数据
export const carTreeRequest = (params?: { search: string }) => {
  return request.get('/api/v2/car/busTree', {
    params
  })
}

// 获取车辆的树形数据 的新接口，项目里没有使用V2
export const carTreeRequestV3 = (params?: { cateId: number }) => {
  return request.get('/api/v2/car/busTreeV3', {
    params
  })
}

//根据分组查询所有车辆以及车辆在线信息
export const getCateCarInfoRequestV2 = (carIds: number[]) => {
  return request.post('/api/v2/car/busTreeV3Update', carIds)
}

//根据分组id查询车辆信息
export const getCateCarInfoRequest = (cateIds: number[]) => {
  return request.post<RListLongResponse>('/api/v2/car/multinode', cateIds)
}


//类型定义
/**
 * R«List«Long»»
 */
export type RListLongResponse = {
  code?: number | null;
  count?: number | null;
  data?: number[] | null;
  ignoreColumns?: string[] | null;
  msg?: null | string;
  success?: boolean | null;
  [property: string]: any;
}